import { useDispatch, useSelector } from "react-redux";
import { ssoLogout } from "../../redux/auth/actions";
import { ACCESS_TOKEN_KEY } from "../../constants";
import { Card, CardContent, Grid, makeStyles, Typography } from "@material-ui/core";

import { Icon } from "../../components/base";
import GearIcon from "../../assets/images/icons/gear.svg";
import LogoutIcon from "../../assets/images/icons/logout.svg";
import UserSvg from "../../assets/images/dashboard/usersvg.svg";
import { PAGES } from "../../pages";
import { useNavigate } from "react-router-dom";
import { selectSystemType } from "../../redux/selectSystem/actions";
import { USER_ROLES } from "../../services/constants";
import { COLORS } from "../../theme/colors";
import { PRAAS_SYSTEM, PROPERTIES_SCIENCE, WORKFLOW_SYSTEM } from "../../constants";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    flexWrap: "noWrap",
  },
  iconSettingsButton: {
    marginLeft: theme.spacing(2),
  },
  avatarIconButton: {
    borderRadius: 100,
    width: 60,
    height: 60,
  },
  email: {
    fontFamily: "Lato",
    display: "inline-block",
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "17px",
    letterSpacing: "0em",
    textAlign: "left",
  },
  navigatorPopup: {
    zIndex: 2,
    right: "50px",
    position: "absolute",
    width: "260px",
    height: "295px",
  },
  settings: {
    border: `1px solid ${COLORS.gray[3]}`,
    alignItems: "center",
    height: "50px",
    margin: "0px",
    cursor: "pointer",
  },
  leftButton: {
    width: "100%",
    height: "32px",
    borderTopLeftRadius: "20px",
    borderBottomLeftRadius: "20px",
    padding: "0px",
    cursor: "pointer",
    color: COLORS.white,
    borderColor: COLORS.white,
    fontFamily: "Lato",
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "14.4px",
    letterSpacing: "-0.02em",
    borderStyle: "solid",
  },
  middleButton: {
    width: "100%",
    height: "32px",
    padding: "0px",
    cursor: "pointer",
    color: COLORS.white,
    borderColor: COLORS.white,
    fontFamily: "Lato",
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "14.4px",
    letterSpacing: "-0.02em",
    borderStyle: "solid",
  },
  rightButton: {
    width: "100%",
    height: "32px",
    borderTopRightRadius: "20px",
    borderBottomRightRadius: "20px",
    padding: "0px",
    cursor: "pointer",
    color: COLORS.white,
    borderColor: COLORS.white,
    fontFamily: "Lato",
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "14.4px",
    letterSpacing: "-0.02em",
    borderStyle: "solid",
  },
  activeButton: {
    backgroundColor: COLORS.purples[0],
  },
  nonActiveButton: {
    backgroundColor: "rgba(33, 33, 33, 0.25)",
  },
}));

export const RightNavigator = ({ show }) => {
  const classes = useStyles();
  const { profileData } = useSelector((state) => state.profile);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { cluster } = useSelector((state) => state.selectCSC);
  const url = window.location.pathname;

  const buttons = [
    {
      text: "PRaaS",
      enable: true,
      className: classes.leftButton,
      page: PAGES.dashboard.index,
      mainPage: PAGES.dashboard.index,
      size: 3,
      system_type: PRAAS_SYSTEM,
    },
    {
      text: "Workspace",
      enable: true,
      className: classes.middleButton,
      page: `${PAGES.workspace.index}/${PAGES.workspace.tasks}`,
      mainPage: PAGES.workspace.index,
      size: 4,
      system_type: WORKFLOW_SYSTEM,
    },
    {
      text: "Properties Science",
      enable: true,
      className: classes.rightButton,
      page: PAGES.buildings.index,
      mainPage: PAGES.buildings.index,
      size: 5,
      system_type: PROPERTIES_SCIENCE,
    },
  ];
  const activeButtonStyle = {
    backgroundColor: COLORS.purples[0],
    "borderLeftWidth": "1px",
    "borderRightWidth": "1px",
  };
  const nonActiveButtonStyle = {
    backgroundColor: COLORS.darks[0][25],
    "borderLeftWidth": "1px",
    "borderRightWidth": "1px",
  };

  const handleClick = (item) => {
    if (item.page) {
      if (item.system_type) dispatch(selectSystemType(item.system_type));
      if (
        item.page === PAGES.workspace.index &&
        cluster.user_role === USER_ROLES.super_pm &&
        !cluster.has_portfolio
      ) {
        navigate(
          `${PAGES.workspace.index}${PAGES.workspace.settings.index}/${PAGES.workspace.settings.portfolioRegistration}`
        );
      } else {
        navigate(item.page);
      }
    }
  };

  const logout = () => {
    ssoLogout({token: localStorage.getItem(ACCESS_TOKEN_KEY)});
    navigate(PAGES.login);
  };

  const goToSettings = () => {
    dispatch(selectSystemType(WORKFLOW_SYSTEM));
    navigate(`${PAGES.workspace.index}${PAGES.workspace.settings.index}`);
  };

  return (
    <>
      {show ? (
        <div>
          <Card className={classes.navigatorPopup}>
            <CardContent style={{ padding: "0px", paddingTop: "15px" }}>
              <Grid container spacing={3} direction="column" alignItems="center" justifyContent="center">
                <Grid item xs={12}>
                  {profileData?.avatar_url ? (
                    <Icon root={classes.avatarIconButton} src={profileData?.avatar_url} hoverable />
                  ) : (
                    <Icon root={classes.avatarIconButton} src={UserSvg} hoverable />
                  )}
                </Grid>
                <Grid item xs={12} style={{ paddingBottom: "8px", paddingTop: "3px" }}>
                  <Typography className={classes.email}>{profileData?.email}</Typography>
                </Grid>
                <Grid
                  item
                  xs={12}
                  container
                  direction="row"
                  spacing={0}
                  style={{ "paddingLeft": "20px", "paddingRight": "20px", paddingBottom: "27px" }}
                >
                  {buttons.map((item, index) => (
                    <Grid item xs={item.size} key={index}>
                      <button
                        className={item.className}
                        onClick={() => handleClick(item)}
                        style={
                          url.startsWith(item.mainPage) ? activeButtonStyle : nonActiveButtonStyle
                        }
                      >
                        {item.text}
                      </button>
                    </Grid>
                  ))}
                </Grid>
                <Grid
                  item
                  xs={12}
                  container
                  direction="row"
                  spacing={2}
                  className={classes.settings}
                  onClick={goToSettings}
                >
                  <Grid item xs={3} style={{ padding: "0px" }}>
                    <Icon root={classes.iconSettingsButton} src={GearIcon} hoverable />
                  </Grid>
                  <Grid item xs={9} style={{ paddingTop: "3px" }}>
                    Settings
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={12}
                  container
                  direction="row"
                  spacing={2}
                  className={classes.settings}
                  onClick={logout}
                >
                  <Grid item xs={3} style={{ padding: "0px" }}>
                    <Icon root={classes.iconSettingsButton} src={LogoutIcon} hoverable />
                  </Grid>
                  <Grid item xs={9} style={{ paddingTop: "3px" }}>
                    Log out
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </div>
      ) : null}
    </>
  );
};
